(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function mountImg(slot, item, opts) {
    if (!slot || !item || !item.src) return;
    const img = document.createElement("img");
    img.src = item.src;
    img.alt = item.alt || "";
    img.decoding = "async";
    img.loading = opts && opts.eager ? "eager" : "lazy";
    img.fetchPriority = opts && opts.eager ? "high" : "auto";

    slot.innerHTML = "";
    slot.appendChild(img);
  }

  function getImagesData(root) {
    const jsonEl = root.querySelector("[data-bratus-images]");
    if (!jsonEl) return {};
    try {
      return JSON.parse(jsonEl.textContent || "{}");
    } catch (e) {
      return {};
    }
  }

  function initImages(root, data) {
    // HERO (1)
    const heroSlot = root.querySelector('[data-img-slot="hero"]');
    if (heroSlot && data.hero) {
      mountImg(heroSlot, data.hero, { eager: true });
    }

    // PANELS (next 5) — Cards are NOT touched here
    const panelSlots = Array.from(root.querySelectorAll('[data-img-slot="panel"]'));
    const panels = Array.isArray(data.panels) ? data.panels : [];

    for (let i = 0; i < panelSlots.length; i++) {
      const item = panels[i];
      if (!item) continue;
      mountImg(panelSlots[i], item, { eager: false });
    }
  }

  function initSlider(root) {
    const slider = root.querySelector("[data-bratus-slider]");
    if (!slider) return;

    const track = slider.querySelector("[data-slider-track]");
    const slides = Array.from(slider.querySelectorAll("[data-slide]"));
    const prevBtn = slider.querySelector("[data-slider-prev]");
    const nextBtn = slider.querySelector("[data-slider-next]");
    const dotsWrap = slider.querySelector("[data-slider-dots]");
    if (!track || slides.length === 0) return;

    // Build dots
    const dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = "";
      slides.forEach((_, i) => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "bratus-dot";
        b.setAttribute("aria-label", `Atvērt norisi ${i + 1}`);
        b.addEventListener("click", () => goTo(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function getStep() {
      if (slides.length >= 2) {
        const step = slides[1].offsetLeft - slides[0].offsetLeft;
        return Math.max(1, step);
      }
      return Math.max(1, slides[0].offsetWidth + 12);
    }

    function nearestIndex() {
      const step = getStep();
      return clamp(Math.round(track.scrollLeft / step), 0, slides.length - 1);
    }

    function setActive(i) {
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    }

    function goTo(i) {
      const step = getStep();
      track.scrollTo({ left: i * step, behavior: "smooth" });
      setActive(i);
    }

    function goBy(dir) {
      goTo(clamp(nearestIndex() + dir, 0, slides.length - 1));
    }

    if (prevBtn) prevBtn.addEventListener("click", () => goBy(-1));
    if (nextBtn) nextBtn.addEventListener("click", () => goBy(1));

    // Keyboard support (when track focused)
    track.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        goBy(-1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        goBy(1);
      }
    });

    // Update active dot on scroll
    let ticking = false;
    track.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setActive(nearestIndex());
        ticking = false;
      });
    });

    const ro = new ResizeObserver(() => setActive(nearestIndex()));
    ro.observe(track);

    setActive(0);
  }

  function initModal(root, imagesData) {
    const modal = root.querySelector("[data-bratus-modal]");
    if (!modal) return;

    const content = modal.querySelector("[data-modal-content]");
    const closeEls = Array.from(modal.querySelectorAll("[data-modal-close]"));
    const openEls = Array.from(root.querySelectorAll("[data-open-modal]"));

    let lastFocus = null;
    
    // Store original position references for returning the modal when closed
    const originalParent = modal.parentElement;
    const modalNextSibling = modal.nextElementSibling;

    function getFocusable(container) {
      return Array.from(
        container.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetParent !== null);
    }

    function lockScroll(lock) {
      // Locking scroll on html/body prevents the background from scrolling (addresses single scroll requirement)
      const cls = "bratus-modal-open";
      if (lock) {
        document.documentElement.classList.add(cls);
        document.body.classList.add(cls);
      } else {
        document.documentElement.classList.remove(cls);
        document.body.classList.remove(cls);
      }
    }

    function openFromCard(card) {
      const details = card.querySelector(".bratus-card__details");
      if (!details) return;

      lastFocus = document.activeElement;

      content.innerHTML = details.innerHTML;

      // === Inject Image Logic ===
      // Find which card index this is to get the correct image from JSON
      const cardIndex = openEls.indexOf(card);
      if (cardIndex !== -1 && imagesData && imagesData.cards && imagesData.cards[cardIndex]) {
        const imgItem = imagesData.cards[cardIndex];
        const modalImgSlot = content.querySelector('[data-img-slot="modal"]');
        if (modalImgSlot) {
            mountImg(modalImgSlot, imgItem, { eager: true });
        }
      }
      // ===============================
      
      // Move modal to body. This ensures fixed positioning is relative to the viewport (centering) 
      // and that the modal is outside the root's filtering context (unblurred card).
      document.body.appendChild(modal);

      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      lockScroll(true);
      
      // Add class to root for background blurring
      root.classList.add("is-modal-open");

      const closeBtn = modal.querySelector("[data-modal-close]");
      if (closeBtn) closeBtn.focus();

      modal.addEventListener("keydown", onKeydown);
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      lockScroll(false);
      
      // Remove class from root when closing modal
      root.classList.remove("is-modal-open");

      content.innerHTML = "";
      
      // Return modal to its original position within the root
      if (originalParent) {
          if (modalNextSibling) {
              originalParent.insertBefore(modal, modalNextSibling);
          } else {
              originalParent.appendChild(modal);
          }
      }

      modal.removeEventListener("keydown", onKeydown);

      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      lastFocus = null;
    }

    function onKeydown(e) {
      if (e.key === "Escape") {
        e.preventDefault();
        closeModal();
        return;
      }

      if (e.key !== "Tab") return;

      const focusable = getFocusable(modal);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    openEls.forEach((card) => card.addEventListener("click", () => openFromCard(card)));
    closeEls.forEach((el) => el.addEventListener("click", closeModal));
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.bratusInitialized === "1") return;
    sectionEl.dataset.bratusInitialized = "1";

    const imagesData = getImagesData(sectionEl);

    initImages(sectionEl, imagesData);   // Handles Hero + Panels
    initSlider(sectionEl);
    initModal(sectionEl, imagesData);    // Passes data for Cards (Modal)
  }

  function initAll() {
    document.querySelectorAll("[data-bratus-stem]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    const container = event.target;
    if (!container) return;
    container.querySelectorAll("[data-bratus-stem]").forEach(initSection);
  });
})();